import { Stack, Box, StackDivider } from "@chakra-ui/react";
import Link from "next/link";
import useSite from "../../../hooks/use-site";
import { urlUpdate } from "../../../support/functions";
import { wpStyles } from "../../../theme/wp-styles";

const Categories = () => {
  const {
    post: { categories },
  } = useSite();

  return (
    <Stack
      direction="row"
      fontSize={wpStyles.fontSize.sm}
      justify="center"
      divider={<StackDivider />}
    >
      {categories.nodes.map(({ link, name, categoryId }) => (
        <Link href={urlUpdate(link)} passHref legacyBehavior key={categoryId}>
          <Box
            as="a"
            textTransform="uppercase"
            textDecor="none"
            color="white"
            fontWeight="semibold"
            _hover={{
              color: "black",
            }}
          >
            {name}
          </Box>
        </Link>
      ))}
    </Stack>
  );
};

export default Categories;
